// extracted by mini-css-extract-plugin
export var formContainer = "_i6-0";
export var message = "_i6-1";